<script>
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import IncludeFlag from '@/components/IncludeFlag';

export default {
  components: {
    'dropdown-block': Multiselect,
    'include-flag': IncludeFlag,
  },
  data() {
    return {
      selectedCountry: {
        code: '',
        id: '',
        name: 'Select country',
        phone_prefix: ''
      },
      selectedStateDefault: {
        code: '',
        id: '',
        name: 'Select state'
      },
      selectedState: {},
      stateList: [],
      mixinUserAccount: {}
    }
  },
  created() {
    this.mixinUserAccount = this.account || this.currentUserAccount; // for form-account, need testing
  },
  computed: {
    ...mapGetters({
      countryList: 'countryList',
      currentUserAccount: 'account/userAccount'
    }),
  },
  methods: {
    ...mapActions({
      getCountryList: 'getCountryList',
      getStateList: 'getStateList'
    }),
    initMixinData() {
      this.selectedState = this.selectedStateDefault;
      this.selectCountryDefault();
      if (!this.countryList.length)
        this.getCountryList();
    },
    selectCountryDefault() {
      if (Object.keys(this.mixinUserAccount).length && this.mixinUserAccount.country_id) {
        this.selectedCountry = '';
        this.selectedCountry = this.countryList.find(country => {
          return country.id == this.mixinUserAccount.country_id;
        });
      } else {
        this.selectedCountry = this.countryList[0];
      }
    }
  },
  watch: {
    selectedCountry(val) {
      if(val && val.id)
        this.getStateList(val.id)
          .then(list => {
            this.stateList = list || [];
            
            if (this.mixinUserAccount.state_id) {
              this.selectedState = list.find(state => {
                return state.id == this.mixinUserAccount.state_id;
              });
            } else {
              this.selectedState = this.selectedStateDefault;
            }
          });
    },
    selectedState(val) {
      if (!val)
        this.selectedState = this.selectedStateDefault;
    },
    mixinUserAccount(val) {
      this.initMixinData();
    }
  }
}
</script>
